import React from 'react';
import styled from 'styled-components';
import  ModalCore from './ModalCore.js';
import { connect } from "react-redux";
import {setValues , actCloseModal} from './redux';
import { Imglist } from './../../constants/ImagesList';

const MessageModal = (props) => {
	return (
		<ModalCore name="message" outSideClick={true}>
			<MessageModalContent className="messagemessage">
                <div className="messagemessage__close" onClick={()=>props.setValues({modal_open: ''})}>
                    <img src={Imglist.btn_close} alt=''/>
                </div>
                <div className="messagemessage__head">
                    แจ้งเตือน
				</div>
                <div className="messagemessage__content">
                    <div className="messagemessage__text-head" dangerouslySetInnerHTML={{__html: props.modal_message}}/>
                </div>
                <div className="messagemessage__ok" onClick={()=>props.setValues({modal_open: ''})}>
					<img src={Imglist.btn_ok} alt=''/>
				</div>
			</MessageModalContent>
		</ModalCore>
	)
}

const mapStateToProps = state => ({
    ...state.Modal
});

const mapDispatchToProps = { setValues ,actCloseModal};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessageModal);

const MessageModalContent = styled.div`
    position: relative;
    z-index: 20;
    padding: 2%;
    pointer-events: visible;
    width: 90%;
    max-width: 700px;
    .messagemessage{
        &__content{
            max-height: 50vh;
            overflow-y: scroll;
            width: 100%;
            margin: 0 auto;
            background: rgba(243,211,230,.8);
            border-bottom-right-radius: 25px;
            padding: 2%;
            min-height: 20vh;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        &__text-head{
            color: #000;
            font-size: 1.5em;
            text-align: center;
        }
        &__head{
            text-align: center;
            font-size: 1.5em;
            color: #fff;
            background: rgba(255,0,76,1);
            background: -moz-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -webkit-gradient(left top, left bottom, color-stop(0%, rgba(255,0,76,1)), color-stop(53%, rgba(255,0,123,1)), color-stop(100%, rgba(255,0,123,1)));
            background: -webkit-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -o-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: -ms-linear-gradient(top, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            background: linear-gradient(to bottom, rgba(255,0,76,1) 0%, rgba(255,0,123,1) 53%, rgba(255,0,123,1) 100%);
            filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ff004c', endColorstr='#ff007b', GradientType=0 );
            border-top-left-radius: 25px;
        }
        &__close{
            position: absolute;
            width: 6%;
            right: -3%;
            top: -3%;
            cursor: pointer;
            >img{
                display: block;
            }
            @media(max-width: 850px) {
                right: 0;
                top: -2%;
            }
        }
        &__ok{
            width: 26%;
            margin: 1% auto 0;
            cursor: pointer;
            &:hover{
                opacity: .8;
            }
            >img{
                display: block;
            }
        }
    }
`;

